






import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'IndexAuth'
})
export default class IndexAuth extends Vue {}
